<template>
   <div>
      <!-- Start the code for this screen here -->

      <div id="column">
         <div class=" marginzero heading" ><span><b>Basic Details</b></span><input type="submit" @click="clearbasicdetails"  class="clearbutton"  value="Clear"></div>

         <div class="card marketvalue-card-height">
         <div v-if="saved">
       <p align ="center" class="confirm-message"> {{message}} </p>
     </div>
     <div v-if="failure">
       <p align ="center" class="alert-danger"> {{failureMessage}} </p>
     </div>
            <div class="frm-group">
               <div class="col-30">
                  <label for="quoteDate" > Quote Date </label>
               </div>
               <div class="col-20">
                  <label for="quoteDate" > {{quoteobject.quote.lm_quote | moment("MM/DD/YYYY")}} </label>
               </div>
               <div class="col-30">
                  <label for="proposedLessee" >  Lessee Name </label>
               </div>
               <div class="col-20">
               <multiselect
    style="width:100%;"
    name="proposedLessee"
    v-model="quoteobject.quote.customer_id"
    :options="customersList"
   v-bind:value="customersList.customerId"
    v-bind:key="customersList.customerId"
    :custom-label="displayFullName"
    selected="selected"
     id="customersdd"
    >

  </multiselect>

               </div>

               <div >
    <b-dropdown id="dropdown-form" text="+" ref="dropdown">
    <div >

 <center><input type="radio"  value="P" id="P" v-model.trim="customertype" class="maxwidth"  @click="Reset()"/>Personal

   <input type="radio"   value="B" id="B" v-model.trim="customertype" class="maxwidth"  @click="Reset()"/>Business</center>

    <div class="frm-group " >
<div   v-if="customertype === 'P'" class="marginleft" >
            <label id="fnamelabel" class="required">First Name</label>
          </div>
           <div   v-if="customertype === 'P'"  class="col-40">
                <input id="fname"
                    placeholder="Enter First Name"
                    v-model.trim="firstName"
                   size="11"
                    maxlength="50" name="First Name" key= "First Name"/>
           </div> </div>
        <div class="frm-group ">
<div  v-if="customertype === 'B'"  class="marginleft" >
             <label id="fnamelabel" class="required">Business Name</label>
            </div>
             <div   v-if="customertype === 'B'" class="col-40">
               <input id="Bname"
                    placeholder="Enter Business Name"
                    v-model.trim="businessName"
                    size="20"
                    data-vv-as="Business Name"
                    maxlength="50"
                    name="Business Name" key= "Business Name"/>
                                       </div>      </div>
<div class="frm-group">
        <div class="marginleft" v-if="customertype === 'B'"> <p align ="center" class="error-message"> {{businessnameerrormessage}} </p> </div>
        <div class="marginleft" v-if="customertype === 'P'"> <p align ="center" class="error-message"> {{firstnameerrormessage}} </p> </div>
        </div>
           <div class="frm-group">
           <div class="marginleft40" >
            <center>  <input type="submit" value="Save" class="addbutton"  @click="savecustomerdata()"> </center>
          </div>
             </div>

     </div>
    </b-dropdown>
  </div>

            </div>

            <div class="frm-group margintopone">
               <div class="col-30">
                  <label for="source"> Source </label>
               </div>
               <div class="col-20">
                  <select name="source" ref="source" v-model="quoteobject.quote.lm_source" v-validate="'required'"  data-vv-as="Source" @change="updateDealer">
           <option disabled value=""> Select a Source </option>
            <option v-for="(option,index) in sources" :value="option.sourceName" :key="index">{{ option.sourceName }}</option>
        </select>
               </div>

               <div class="col-30">
                  <label for="dealerName"> Dealer Name </label>
               </div>
               <div class="col-20">
       <select  name="dealerName" v-model="quoteobject.quote.dealer_id">
          <option disabled value=""> Select a Dealer </option>
             <option v-for="(option,index) in sortedDealers" v-bind:value="option.dealerId" v-bind:key="index"> {{ option.dealerName }} </option>
        </select>

               </div>
               <div>
    <b-dropdown id="dropdown-form" text="+" ref="dropdown" class="m-2">
       <div class="frm-group">
      <div class="marginleft">
        <label for="dealerName" class="required" > Dealer Name </label>
        </div>
        <div class="col-40">
        <input type="text" data-vv-as="Dealer Name" v-validate="'required'" key="Dname" name="DName" v-model.trim="dealerName" autofocus placeholder="Enter Dealer Name" :maxlength="100"  >

        </div></div>
         <div class="frm-group">
        <div class="marginleft"> <p align ="center" class="error-message"> {{dealernameerrormessage}} </p> </div>
        </div>
     <div class="frm-group">
     <div class="marginleft40" >
      <center>  <input type="submit" value="Save" class="addbutton" @click="saveDealer()"></center>
      </div>
        </div>

    </b-dropdown>
  </div>
            </div>

            <div class="frm-group margintopone">
               <div class="col-30">
                  <label > Total Payments</label>
               </div>
               <div class="col-20">
                  <input type="Text" placeholder="Enter Total Payments" @input="handlenumbers" v-model="quoteobject.quote.de_total_payments" />
               </div>
               <div class="col-30">
                  <label for="salesAgent" > Salesperson Name </label>
               </div>
               <div class="col-20 marginright">
                  <select  name="saleagent" data-vv-as="Sales Agent" v-model.trim="quoteobject.quote.employee_id" v-validate="'required_if:source,Dealer'" @change="updateDealer">
          <option  disabled value=""> Select Salesperson </option>
             <option v-for="(option) in agentList" v-bind:value="option.employeeId" v-bind:key="option.employeeId"> {{ option.firstName }} {{ option.middleName.length !=0 ?  ',' +option.middleName : ''}} , {{ option.lastName }} </option>
        </select>

               </div>

            </div>

            <div class="frm-group margintopone">
               <div class="col-30">
                  <label > Advance Payments</label>
               </div>
               <div class="col-20">
                  <input type="Text"  placeholder="Enter Advance Payments" @input="handletextnumbers"  v-model="quoteobject.quote.de_advance_payments" maxlength="2"/>
               </div>
               <div class="col-30">
                  <label for="leaseType"> Lease Type </label>
               </div>
               <div class="col-20 marginright">
                  <select name="leaseType" v-model="quoteobject.quote.lm_lease_type">
                     <option disabled value=""> Select a Lease Type </option>
                      <option > Lease </option>
                       <option > Sale</option>
                        <option > LeaseBack </option>

                  </select>
               </div>
            </div>
            <div class="frm-group margintopone">
               <div class="col-30">
                  <label for="remainingPayments"> Remaining Payments</label>
               </div>
               <div class="col-20">
                  <label v-model="quoteobject.quote.de_remaining_payments" class="labelright"> {{calcRemainingPayments}}</label>
               </div>
               <div class="col-30">
                 <label for="Veteranstatus"> Veteran status </label>
            </div>
            <div class="col-15 font12 marginright">

                 <input type="radio" name="radio1" value="Y" class="maxwidth">Yes
                 <input type="radio" name="radio1" value="N"  class="maxwidth">No
            </div>

            </div>
            <div class="frm-group margintopone">
               <div class="col-30"> <label > Customer type</label> </div>
               <div class="col-20 marginright">
                  <label for="customertype">{{customerType|formatCustType}}  </label>
               </div>
               <div class="col-30"></div>
               <div class="col-20">
               </div>
            </div>
            <div class="frm-group margintopone">
               <template v-if="quoteobject.quote.lm_source === 'InHouse'">
                  <div class="col-30">
                     <label for="InhouseName"> Inhouse Values</label>
                  </div>
                  <div class="col-20">
                     <select name="InhouseName"  v-model="quoteobject.quote.lm_inhouse_category" >
                        <option disabled value=""> Select a Inhouse value </option>
                        <option v-for="(option,index) in inhouseList" :value="option.inhouseValue" :key="index">{{ option.inhouseValue }}</option>
                     </select>
                  </div>
               </template>
            </div>
         </div>
      </div>
      <div id="column">

         <div class="heading marginzero" ><span><b>Vehicle Details</b></span><input type="submit" class="clearbutton" @click="clearvehiclevalues()"   value="Clear"></div>
         <div class="card marketvalue-card-height">
         <div class="frm-group">
               <div class="col-30">
                 <input type="checkbox"   v-model="checked" id="ObjChkId"  @click="disabledvehicleinfo()" class="maxwidth" checked>Valuation by VIN
               </div>
               </div>
            <div class="frm-group">
               <div class="col-30">
                  <label for="Vin"> VIN</label>
               </div>
               <div class="col-20">
               <input type="text" :disabled="disablevinnumber" v-model="quoteobject.quote.lm_vin" placeholder="Enter VIN" @change="getvehicleinfo()">
               </div>
               <div class="col-30">
                  <label for="Odometer">Odometer Reading </label>
               </div>
               <div class="col-20">
                  <input type="text"   name="Odometer"  placeholder="Enter Odometer Reading ">
               </div>

            </div>
            <div class="frm-group margintopone">
               <div class="col-30">
                  <label for="year"> Year </label>
               </div>
               <div class="col-20">
               <label v-show="disabledvehicleinformation">{{quoteobject.quote.lm_year}}</label>
                      <multiselect
    style="width:100%"
    v-model="quoteobject.quote.lm_year"
    :options="yearlist"
    selected="selected"
    id="customersdd"
    v-show="disablevehicleinfo"
    @input="getmake()">
  </multiselect>

               </div>
                <div class="col-30">
                  <label for="Odometer">Annual Odometer  </label>
               </div>
               <div class="col-20">
                  <input type="text"   name="Odometer"  placeholder="Enter Annual Odometer">
               </div>

            </div>
            <div class="frm-group margintopone">
               <div class="col-30">
                  <label for="make"> Make </label>
               </div>
               <div class="col-20">
<label v-show="disabledvehicleinformation">{{quoteobject.quote.lm_make}}</label>
   <multiselect
    style="width:100%"
    v-model="quoteobject.quote.lm_make"
    :options="makelist"
    selected="selected"
    v-show="disablevehicleinfo"
    id="customersdd" @input="getmodel()">
  </multiselect>

               </div>
                <div class="col-30">
                  <label for="Vin"> Original MSRP</label>
               </div>
               <div class="col-20">
                  <input type="text"   name="msrp"  v-model="quoteobject.quote.lm_original_msrb" placeholder="Enter Original MSRP" >
               </div>

            </div>
            <div class="frm-group margintopone">
               <div class="col-30">
                  <label for="model"> Model </label>
               </div>
               <div class="col-20">
               <label v-show="disabledvehicleinformation">{{quoteobject.quote.lm_model}}</label>
                <multiselect
    style="width:100%"
    v-model="quoteobject.quote.lm_model"
    :options="modallist"
    selected="selected"
    id="customersdd"
    v-show="disablevehicleinfo"
    @input="getstyle">
  </multiselect>

               </div>
               <div class="col-30">
                  <label for="InhouseName">Fuel Type</label>
               </div>
               <div class="col-20">
                  <select name="FuelType"  v-model="quoteobject.quote.lm_fuel_type">
                     <option disabled value=""> Select Fuel Type </option>
                     <option>Gasolene</option>
                     <option >Diesel</option>
                  </select>
               </div>

            </div>
            <div class="frm-group margintopone">
               <div class="col-30">
                  <label for="model"> Style </label>
               </div>
               <div class="col-20">
               <label v-show="disabledvehicleinformation">{{quoteobject.quote.lm_style}}</label>
                  <multiselect
    style="width:100%"
    v-model="quoteobject.quote.lm_style"
    :options="stylelist"
    selected="selected"
    v-show="disablevehicleinfo"
    id="customersdd">
  </multiselect>

               </div>
               <div class="col-30">
                  <label for="Vin">  Curb Weight</label>
               </div>
               <div class="col-20">
                  <input type="text"   name="Curbweight"  v-model="quoteobject.quote.lm_curb_weight"  placeholder="Enter Curb Weight" >
               </div>
            </div>
            <div class="frm-group margintopone">

<div class="col-30">
                  <label for="currentMiles"> Color </label>
               </div>
               <div class="col-20">
                 <multiselect
    style="width:100%"
    v-model="quoteobject.quote.lm_color"
    :options="colorlist"
    selected="selected"
    id="customersdd">
  </multiselect>

               </div>
<div class="col-30"></div>
 <div class="col-20"></div>
            </div>
            <input type="submit" v-show="showadmincorporatebutton" value="Show Admin Corporate" id="customerbutton" @click="showadmincorporate">
            <input type="submit"  v-show="hiddenadmincorporatebutton"  value="Hidden Admin Corporate" id="customerbutton" @click="hiddenadmincorporate">
         </div>
      </div>
<div id="column1" v-show="admincorporate">
            <div class=" marginzero heading"  ><span><b>Admin Corporate</b></span></div>
            <div class="card">
               <table  class="table-month-table">
                  <tr class="table-month-row">
                     <th v-for="(col,index) in colheaders" :key="index" class="table-month-header-blue"><span >{{col.header}}</span></th>
                  </tr>
                  <tr v-for="data in quotelist">
                     <td class="table-month-td">{{data.lm_year}}</td>
                     <td class="table-month-td">{{data.lm_make}}</td>
                      <td class="table-month-td">{{data.lm_model}}</td>
                           <td class="table-month-td"><span class="reportLink"  title="click to open" target= "_blank" @click="openlink(app)">{{data.link}}</span></td>

                  </tr>
               </table>
            </div>
         </div>

      <div id="column1">

<div class="heading marginzero"><span><b>Market Value</b></span><input type="submit" class="clearbutton" @click="clearmarketvalue()" value="Clear"><input type="submit" class="clearbutton"  value="Copy"><input type="submit" class="clearbutton"  value="Get Recent"></div>
       <div class="card marketvalue-table-card-height">
                <table  class="table-month-table">
                <tr >
                   <th class="table-month-header-red" rowspan="2">Year</th>
                   <th class="table-month-header-red" colspan="7">Manheim Data</th>
                   <th class="table-month-header-red" colspan="3">Black Book</th>
                   <th class="table-month-header-red" rowspan="2">Base Evaluation</th>
                   <th class="table-month-header-red"  colspan="3">Judgmental Adjustments</th>
                   <th class="table-month-header-red" rowspan="2">Final Valuation</th>
                   <th class="table-month-header-red" rowspan="2">Valuation Comments</th>
                </tr>
                <tr >
                   <th class="table-month-header-blue">MMR</th>
                   <th class="table-month-header-blue">Comp#1</th>
                   <th class="table-month-header-blue" >Comp#2</th>
                   <th class="table-month-header-blue">Comp#3</th>
                   <th class="table-month-header-blue">Comp#4</th>
                   <th class="table-month-header-blue">Comp#5</th>
                   <th class="table-month-header-blue">Comp#6</th>
                   <th class="table-month-header-blue">Excellent</th>
                   <th class="table-month-header-blue">Good</th>
                   <th class="table-month-header-blue">Fair</th>
                   <th class="table-month-header-blue">Equipment</th>
                   <th class="table-month-header-blue">Market</th>
                   <th class="table-month-header-blue">Other</th>
                </tr>

                <tr class="table-month-row" v-for="index in paymentRows">
                    <tr class="table-month-row" v-for="(marketvalue,index) in quoteobject.marketvalue">
                    <td class="table-month-td" v-if="index==0"> @Inception</td>
                      <td class="table-month-td" v-else> @Month {{displayMonth(index)}}</td>

   <template class="table-month-row" v-for="manheimdata in marketvalue.manheimdata">
     <td class="table-month-td" >{{manheimdata.mmr}} <input type="text" class="inputsize1" v-model="manheimdata.mmr"></td>
     <td class="table-month-td"> {{manheimdata.comp1}}<input type="text" class="inputsize1" v-model="manheimdata.comp1"> </td>
      <td class="table-month-td">{{manheimdata.comp2}}<input type="text" class="inputsize1"  v-model="manheimdata.comp2">  </td>
        <td class="table-month-td">{{manheimdata.comp3}}<input type="text" class="inputsize1" v-model="manheimdata.comp3">  </td>
          <td class="table-month-td">{{manheimdata.comp4}}<input type="text" class="inputsize1" v-model="manheimdata.comp4">  </td>
            <td class="table-month-td"> {{manheimdata.comp5}} <input type="text" class="inputsize1"  v-model="manheimdata.comp5"></td>
              <td class="table-month-td">{{manheimdata.comp6}}<input type="text" class="inputsize1"  v-model="manheimdata.comp6">  </td>

    <template v-for="(blackbook) in marketvalue.blackbook">
    <td class="table-month-td" >{{blackbook.excellent}} <input type="text" class="inputsize1"  v-model="blackbook.excellent"></td>
     <td class="table-month-td"> {{blackbook.good}}<input type="text" class="inputsize1" v-model="blackbook.good"> </td>
      <td class="table-month-td"> {{blackbook.fair}}<input type="text" class="inputsize1" v-model="blackbook.fair"> </td>

       <template v-for="(baseevaluation) in marketvalue.baseevaluation">
        <td class="table-month-td cell-breakWord" v-if="manheimdata.mmr == 0" >{{baseevaluation.base_evaluation = ((parseInt(manheimdata.comp1)+parseInt(manheimdata.comp2)+parseInt(manheimdata.comp3)+parseInt(manheimdata.comp4)+parseInt(manheimdata.comp5)+parseInt(manheimdata.comp6)+parseInt(blackbook.good))/7).toFixed(0)}}</td>
    <td class="table-month-td" v-if="manheimdata.mmr!=0" >{{baseevaluation.base_evaluation = manheimdata.mmr}}</td>

       <template v-for="(judgmentaladjustments) in marketvalue.judgmentaladjustments">
    <td class="table-month-td" >{{judgmentaladjustments.equipment}} <input type="text" class="inputsize1" v-model.Number="judgmentaladjustments.equipment"></td>
     <td class="table-month-td" >{{judgmentaladjustments.market}} <input type="text" class="inputsize1"v-model.Number="judgmentaladjustments.market"></td>
      <td class="table-month-td" >{{judgmentaladjustments.other}} <input type="text" class="inputsize1"  v-model.Number="judgmentaladjustments.other"></td>

    <td class="table-month-td" >{{parseInt(baseevaluation.base_evaluation)+parseInt(judgmentaladjustments.equipment)+parseInt(judgmentaladjustments.market)+parseInt(judgmentaladjustments.other)}} </td>

    </template>

       </template>  </template> </template>
       <td class="table-month-td" ><textarea rows = "num" cols = "num"></textarea></td>
   </tr>

             </table>
         </div>

      <div id="marginright">
         <button id="tabbutton" @click="quoteobject.quote.tabIndex++" >Next</button>
         <div id="savelaterbutton">
            <input type="submit" value="Save Later" id="tabbutton" @click="savelaterpopup()">
         </div>
         <input type="submit" value="Clear" id="tabbutton" @click="cleartotalvalues()">
      </div>
      <div id="savemodal" class="popup">
         <div class="popup-topcontent" >
            <span>Save Later</span>
            <span class="savelaterclose" id="test">x</span>
         </div>
         <div class="popup-content">
            <center>
               <p>Are you sure you want to save this for a later use?</p>
               <input type="submit" value="Yes" id="customerbutton">
               <input type="submit" value="No" id="customerbutton">
            </center>
         </div>
         </div>
      </div>
   </div>
   <!-- End of the code for this screen here -->
</template>
<script>
import httpcustomer from '../js/http-customer.js'
import httpsource from '../js/http-managesource.js'
import httpemployee from '../js/http-employee.js'
import vendorintegration from '../js/http-vendorintegration'
import vuetab from '@/css/dropdownwithform.css'
import axios from 'axios'
import quotejsonobject from '../json/quote.json'
import generatequoteobjects from '@/object/quotes.js'

import moment from 'moment'
export default {
  props: ['quoteobject', 'quoteobject1'],
  components: {

  },
  name: 'MarketValue',
  data () {
    return {
      admincorporate: false,
      showadmincorporatebutton: true,
      hiddenadmincorporatebutton: false,
      quoteobjects: generatequoteobjects,
      quotejson: quotejsonobject,
      valuation_by_vin: '',
      customertype: 'P',
      customername: '',
      disablevehicleinfo: false,
      disablevinnumber: false,
      disabledvehicleinformation: true,
      businessnameerrormessage: '',
      firstnameerrormessage: '',
      checked: true,
      agentList: [],
      dealersList: [],
      customersList: [],
      vinnumberlist: [],
      hiddendealername: true,
      hiddenlesseename: true,
      makelist: [],
      modallist: [],
      stylelist: [],
      colorlist: [],
      yearlist: [],
      selectedQuoteId: this.$store.state.lmQuoteId,
      quotelist: [],
      firstName: '',
      dealerName: '',
      businessName: '',
      dealeremail: 'dealer' + moment(new Date()).format('MMDDYYYYhhmmss') + '@system.com',
      dealernameerrormessage: '',
      colheaders: [
        { header: 'Year' },
        { header: 'Make' },
        { header: 'Model' },
        { header: 'Link' }

      ],
      saved: false,
      message: '',
      failure: false,
      failureMessage: "We're unable to save dealer information",
      msgcolor: {
        color: 'black'
      },
      sources: [{ sourceName: 'Dealer' }, { sourceName: 'InHouse' }],
      inhouseList: [
        { inhouseValue: 'Dupont Registry' },
        { inhouseValue: 'Sports Car Markett' },
        { inhouseValue: 'Google' },
        { inhouseValue: 'Instagram' },
        { inhouseValue: 'Facebook' },
        { inhouseValue: 'Existing Customer' },
        { inhouseValue: 'Other' }
      ]
    }
  },

  methods: {

    fetchData () {
      // this.$store.state.lmQuoteIds =''
      // this.quoteobject.quote.lm_source=''
      // this.quoteobject.quote= this.quoteobjects.quote
      // this.quoteobject.quote= this.quoteobject1.quote
      // console.log(this.quoteobject.quote)
      // console.log(this.quoteobjects.quote)
      // console.log(this.quoteobject1.quote)

      this.retrieveCustomerList()
      this.retrieveAgentList()
      this.getyears()
      this.getcolor()
    },
    showadmincorporate () {
      this.admincorporate = true
      this.showadmincorporatebutton = false
      this.hiddenadmincorporatebutton = true
    },
    hiddenadmincorporate () {
      this.admincorporate = false
      this.hiddenadmincorporatebutton = false
      this.showadmincorporatebutton = true
    },
    openlink (app) {
      window.open('https://google.com', '_blank')
    },
    savecustomerdata: function () {
      if (this.firstName == '') {
        this.firstnameerrormessage = 'The First Name Field is required'
      }
      if (this.businessName == '') {
        this.businessnameerrormessage = 'The Business Name field is required'
      }
      if (this.firstName != '' || this.businessName != '') {
        this.businessnameerrormessage = ''
        this.firstnameerrormessage = ''
        this.createCustomer()
      }
    },

    createCustomer () {
      var date = new Date()
      var currentDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
      let newCustomer = {
        'firstName': this.firstName,
        'customerType': this.customertype,
        'dealerId': null,
        'businessName': this.businessName,

        'address': {

          'creationD': date,
          'creationUserI': this.$session.get('user_id')

        },
        'digitalContactInfo': {

          'email': ''

        },
        'inactiveD': null,
        'creationD': date,
        'creationUserI': this.$session.get('user_id'),
        'lastUpdatedD': null,
        'lastUpdatedUserI': null
      }
      // console.log(newCustomer)
      httpcustomer.post('/customer/', newCustomer).then(response => {
        // console.log("test")
        var status = response.data
        if (status == 'CREATED') {
          this.saved = true
          this.message = 'Customer Successfully added into the system'
          this.msgcolor.color = 'Blue'
        } else {
          this.msgcolor.color = 'Red'
          this.message = ''
        }
      })
        .catch(e => {
          this.msgcolor.color = 'Red'
          this.message = '' || e.name || e.message
        })
    },

    retrieveCustomerList () {
      httpcustomer.get('/customer/').then(response => {
        this.customersList = response.data
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    test () {
      if (this.$router.path != '/quoteGeneration') {
        this.quoteobject.quote.de_advance_payments = ''
        let obj = {
          a: this.quoteobject.quote,
          b: this.quoteobject1.quote
        }
        let copy = obj
        obj.a = obj.b

        this.quoteobject.quote = obj.a
        console.log(copy.a)
      }
    },
    retrievequotejson () {
      this.quotelist = this.quotejson
      if (this.selectedQuoteId == this.quotelist[0].lmQuoteId) {
        this.quoteobject.quote = this.quotelist[0]
        console.log(this.quoteobject.quote = this.quotelist[0])
        console.log(this.quotelist[0])
      }
    },

    saveDealer () {
    // this.$validator.validateAll().then(() => {
      // if (!this.errors.any()) {
      var text
      if (this.dealerName == '') {
        text = 'The Dealer Name field is Required'
        this.dealernameerrormessage = text
      } else if (this.dealerName != '') {
        var date = new Date()
        var currentDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
        let addDealerPayload = {
          'dealerName': this.dealerName,

          'address': {

            'creationUserI': this.$session.get('user_id')

		            },
		            'digitalContactInfo': {

            'email': this.dealeremail

          },

          'dealerStatue': 'A',
          'priority': 1,
	    		'creationUserI': this.$session.get('user_id'),
	    		'lastUpdatedD': null,
	    		'lastUpdatedUserI': null
        }
        // console.log(addDealerPayload);
        // Call REST API
        httpsource
          .post('/dealer', addDealerPayload)
          .then(response => {
            var status = response.data
            if (status == 'CREATED') {
              this.saved = true
              this.dealernameerrormessage = ''
              this.message = 'Dealer has been saved successfully!!!'
              this.errors.clear()
              this.$validator.reset()
            } else if (status == 'BAD_REQUEST') {
            // console.log("Failed to save Dealer!!");
              this.failure = true
            } else if (status == 'CONFLICT') {
            // Dealer already exists
              this.failure = true
              this.failureMessage = 'Dealer Name Already exists'
            } else {
            // console.log("Failed to save Dealer!!");
              this.failure = true
            }
          })
          .catch(e => {
            console.log('Failed: ' + e)
            this.failure = true
          })

        // }
        // });
      }
    },

    clearDealer () {
      this.hiddendealername = true
      this.dealerName = ''
      this.$validator.reset()
    },
    clearCustomer () {
      this.hiddenlesseename = true
      this.firstName = ''
      this.businessName = ''
      this.$validator.reset()
    },
    Reset () {
      this.firstName = '',
      this.businessName = '',
      this.$validator.reset()
      this.message = ''
      this.businessnameerrormessage = ''
      this.firstnameerrormessage = ''
    },

    displayFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    retrieveAgentList () {
      let searchEmployee = this.createSearchObject()
      httpemployee.post('/employee/search/', searchEmployee).then(response => {
        this.agentList = response.data
        var customerlist = response.data
        var customerobject = customerlist[0]
        if (customerobject.employeeId == this.selectedEmployeeId) {
          this.quote.selectedEmployeeId = customerobject.firstName + ',' + customerobject.middleName + ' ' + customerobject.lastName
        }
      })
        .catch(e => {
          this.errorslist.push(e)
        })
    },
    createSearchObject () {
      return {
        'firstName': '',
        'lastName': '',
        'roleType': '',
        'statusCode': 'A'
      }
    },
    retrieveDealerList () {
      httpsource.get('/dealer/').then(response => {
        this.dealersList = response.data
        // console.log(this.dealersList)
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },

    disabledvehicleinfo () {
      var checkBox = document.getElementById('ObjChkId')
      if (checkBox.checked == true) {
        this.disablevehicleinfo = false
        this.disablevinnumber = false
        this.disabledvehicleinformation = true
      } else {
        this.disablevehicleinfo = true
        this.disablevinnumber = true
        this.disabledvehicleinformation = false
        this.quoteobject.quote.lm_vin = ''
      }
      this.Resetcheckbox()
    },
    Resetcheckbox () {
      this.quoteobject.quote.lm_make = ''
      this.quoteobject.quote.lm_year = ''
      this.quoteobject.quote.lm_model = ''
      this.quoteobject.quote.lm_style = ''
      this.quoteobject.quote.lm_color = ''
    },

    updateDealer () {
      this.dealersList = []
      if (this.quoteobject.quote.lm_source	 == 'InHouse') {
        httpsource.get('/dealersearch').then(response => {
          if (response.data.length != 0) {
            this.dealersList = []
            this.dealersList = response.data
          }
        })
          .catch(error => {
            console.log('Failed to load dealers:' + error)
          })
      } else if (this.quoteobject.quote.employee_id != '') {
        httpemployee.get('/employee/' + parseInt(this.quoteobject.quote.employee_id)).then(response => {
          this.dealersList = []
          this.quoteobject.quote.dealer_id = ''
					 for (var i = 0; i < response.data.length; i++) {
            var employeeobject = response.data[i]
            for (var i = 0; i < employeeobject.empBusinessCoverageAreas.length; i++) {
              var empbuscovarea = employeeobject.empBusinessCoverageAreas[i]
              this.dealersList.push({
                'dealerId': empbuscovarea.id.dealerId,
                'dealerName': empbuscovarea.ddealerInfo.dealerName
              })
            }
					 }
        }).catch(e => { console.log(e) })
      }
    },

    addlesseename: function () {
      this.hiddenlesseename = false
    },
    adddealername: function () {
      this.hiddendealername = false
    },
    getvehicleinfo () {
      if (this.quoteobject.quote.lm_vin != '') {
        vendorintegration.get('vehicleInfo/vin/' + this.quoteobject.quote.lm_vin).then(response => {
          console.log(response.data)
          this.quoteobject.quote.lm_make = response.data.make
          this.quoteobject.quote.lm_model = response.data.model
          this.quoteobject.quote.lm_year = response.data.year
          this.quoteobject.quote.lm_style = response.data.trim
        })
      }
      if (this.quoteobject.quote.lm_vin == '') {
        this.quoteobject.quote.lm_make = ''
        this.quoteobject.quote.lm_model = ''
        this.quoteobject.quote.lm_year = ''
        this.quoteobject.quote.lm_style = ''
      } else {
        this.quoteobject.quote.lm_make = ''
        this.quoteobject.quote.lm_model = ''
        this.quoteobject.quote.lm_year = ''
        this.quoteobject.quote.lm_style = ''
      }
    },

    getyears () {
      vendorintegration.get('vehicleInfo/years/').then(response => {
        this.yearlist = response.data
      })
    },

    getmake () {
      vendorintegration.get('vehicleInfo/makes/' + this.quoteobject.quote.lm_year).then(response => {
        this.makelist = response.data
      })
    },
    getmodel () {
      vendorintegration.get('vehicleInfo/models/' + this.quoteobject.quote.lm_year + '/' + this.quoteobject.quote.lm_make).then(response => {
        this.modallist = response.data
      })
    },
    getcolor () {
      vendorintegration.get('vehicleInfo/colors').then(response => {
        this.colorlist = response.data
      })
    },
    getstyle () {
      vendorintegration.get('vehicleInfo/trims/' + this.quoteobject.quote.lm_year + '/' + this.quoteobject.quote.lm_make + '/' + this.quoteobject.quote.lm_model).then(response => {
        this.stylelist = response.data
      })
    },

    clearbasicdetails () {
      this.quoteobject.quote.customer_id = ''
      this.quoteobject.quote.employee_id = ''
      this.quoteobject.quote.lm_source	= ''
      this.quoteobject.quote.lm_lease_type = ''
      this.quoteobject.quote.de_total_payments = ''
      this.quoteobject.quote.de_remaining_payments = ''
      this.quoteobject.quote.lm_proposed_lessee_name = ''
      this.quoteobject.quote.lm_loan_amount = ''
      this.quoteobject.quote.dealer_id = ''
      this.quoteobject.quote.de_advance_payments = ''
      this.quoteobject.quote.lm_inhouse_category = ''
      this.hiddenlesseename = true
      this.hiddendealername = true
    },
    clearmarketvalue () {
      this.quoteobject.marketvalue = []
    },
    clearvehiclevalues () {
      this.quoteobject.quote.lm_vin = ''
      this.quoteobject.quote.lm_color = ''
      this.quoteobject.quote.lm_miles = ''
      this.quoteobject.quote.lm_model = ''
      this.quoteobject.quote.lm_make = ''
      this.quoteobject.quote.lm_year = ''
      this.quoteobject.quote.lm_style = ''
      this.quoteobject.quote.lm_curb_weight = ''
      this.quoteobject.quote.lm_fuel_type = ''
      this.quoteobject.quote.lm_original_msrb = ''
    },

    cleartotalvalues () {
      this.quoteobject.quote.customer_id = ''
      this.quoteobject.quote.employee_id = ''
      this.quoteobject.quote.lm_source	= ''
      this.quoteobject.quote.lm_lease_type = ''
      this.quoteobject.quote.de_total_payments = ''
      this.quoteobject.quote.de_remaining_payments = ''
      this.quoteobject.quote.lm_loan_amount = ''
      this.quoteobject.quote.dealer_id = ''
      this.quoteobject.quote.de_advance_payments = ''
      this.quoteobject.quote.lm_vin = ''
      this.quoteobject.quote.lm_color = ''
      this.quoteobject.quote.lm_miles = ''
      this.quoteobject.quote.lm_model = ''
      this.quoteobject.quote.lm_make = ''
      this.quoteobject.quote.lm_year = ''
      this.quoteobject.quote.lm_style = ''
      this.quoteobject.quote.lm_curb_weight = ''
      this.quoteobject.quote.lm_fuel_type = ''
      this.quoteobject.quote.lm_original_msrb = ''
      this.quoteobject.marketvalue = []
    },
    displayMonth (row) {
      try {
        if ((Math.floor((this.quoteobject.quote.de_total_payments) / (row * 12)) > 0)) {
          return row * 12
        } else { return this.quoteobject.quote.de_total_payments }
      } catch (e) {
        return 1
      }
    },

    handlenumbers (e) {
      let stringValue = e.target.value.toString()
      let regex = /^([1-9]|[1-6][0-9]|7[0-2])$/
      if (!stringValue.match(regex) && this.quoteobject.quote.de_total_payments !== '') {
        this.quoteobject.quote.de_total_payments = 1
      }
    },

    handletextnumbers (e) {
      let stringValue = e.target.value.toString()
      let regex = /^([0-3])$/
      if (!stringValue.match(regex) && this.quoteobject.quote.de_advance_payments !== '') {
        this.quoteobject.quote.de_advance_payments = 0
      }
    },
    savelaterpopup () {
      var popup = document.getElementById('savemodal')
      var btn = document.getElementById('savelaterbutton')
      var span = document.getElementsByClassName('savelaterclose')[0]
      btn.onclick = function () {
        popup.style.display = 'block'
      }
      span.onclick = function () {
        popup.style.display = 'none'
      }

      window.onclick = function (event) {
        if (event.target == popup) {
          popup.style.display = 'none'
        }
      }
    },
    calcFinalEvaluation (i) {
      this.finalevaluation = ''
      // console.log(this.finalevaluation)
      return this.finalevaluation
    }
  },
  filters: {
    formatCustType (customerType) {
      if (customerType == '') {
        return 'Personal/Business'
      } else if (customerType == 'B') {
        return 'Business'
      } else if (customerType == 'P') {
        return 'Personal'
      }
    }
  },
  computed: {

    calcRemainingPayments () {
      this.quoteobject.quote.de_remaining_payments = Number(this.quoteobject.quote.de_total_payments) - Number(this.quoteobject.quote.de_advance_payments)
      return this.quoteobject.quote.de_remaining_payments
    },

    customerType: function () {
      var custSelect = this.quoteobject.quote.customer_id.customerId
      var custType = ''
      if (this.quoteobject.quote.customer_id.customerId != '') {
        this.customersList.forEach(customerObj => {
          if (customerObj.customerId == custSelect) {
            custType = customerObj.customerType
          }
        })
      }
      return custType
    },
    sortedDealers: function () {
      return this.dealersList.sort((a, b) => { return a.dealerName > b.dealerName ? 1 : -1 })
    },
    paymentRows () {
      if (isNaN(this.quoteobject.quote.de_total_payments) > 0) {
        return 1
      }
      if (Number(this.quoteobject.quote.de_total_payments) > 72) {
        return 1
      }

      return Math.ceil(this.quoteobject.quote.de_total_payments / 12) + 1
    }

  },

  mounted () {
    // this.test()
    /* let obj = {
  a: this.quoteobject.quote,
  b: this.quoteobject1.quote,
};
let copy = obj;
obj.a = obj.b
this.quoteobject.quote = obj.a
console.log(copy.a); */

    this.quoteobject.quote = this.quoteobject1.quote
    // console.log(this.quoteobject.quote)

    // Object.assign(this.quoteobject.quote, this.quoteobject1.quote);
    console.log(this.quoteobject.quote)
    this.fetchData()
    this.selectedQuoteId = this.$store.state.lmQuoteId
    if (this.selectedQuoteId != '') {
      this.retrievequotejson()
    }
    this.$store.state.lmQuoteId = ''
    console.log(this.quoteobject1.quote)
    console.log(this.quoteobject.quote)
  }
}
</script>
<style scoped>

.error-message{
     color: red;
    border-color: #333;
   font-size:12px;
     display: block;
     margin-left:40px;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
  }
   .frm-group {
     /** display: -webkit-flex;  **/
     display: flex;
     flex-flow: row;
     align-items: left;
     width:100%;
 }
   .frm-group label {
     text-align: left;
     font-size: 12px;
     vertical-align: bottom;
     margin: 8px 15px 0px 10px;
     display:block;
     font-family: Verdana, Geneva, Tahoma, sans-serif;
 }
 textarea {
     width: 100px;
     height: 50px;
 }

 .frm-group input {
     width: 100%;
     white-space: nowrap;
     border: 1px solid #ddd;
     border-radius: 5px;
     resize: vertical;
     font-size:12px;
     margin: 5px 10px 0px 0px;
 }
    .frm-group select {
     width: 100%;
     border: 1px solid #ddd;
     border-radius: 5px;
     font-size:12px;
     resize: vertical;
     margin: 5px 10px 0px 0px;

 }
 .reportLink {
     cursor:pointer;
     color:blue;
     text-decoration:none;
}
 .marginleft {
 	margin-left: 10%;
 }
 .marginleft40{
    margin-left:40%;
 }
    #column {
    float: left;
    width: 50%;
    padding: 1px;
    }
    #column1 {
    float: left;
    width: 100%;
    padding: 1px;
    }
    .margin20{
    margin-left: 10%
    }
    .marketvalue-card-height{
    height:280px;
    padding-top:0px
    }
     .marketvalue-table-card-height{
    height:430px;
    padding-top:0px
    }
    .col-30{
    float:right;
    width:27%;
    font-size: 12px;
    }
    .cell-breakWord {
    word-wrap: break-word;
    max-width: 1px;
 }

    .clearbutton{
    float:right;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    color: white;
    cursor: pointer;
    border-radius:5px;
    padding: 3px 20px 3px 20px;
    }
    .popup {
    display: none;
    position: fixed;
    z-index: 1;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
    }
    .popup-content {
    overflow: hidden;
    border:1px solid #00529B;
    background:white;
    padding: 10px 0px 10px 0px;
    border-top:none;
    width:45%;
    margin:0px 400px;
    }
    .popup-topcontent{
    background-color: dodgerblue;
    margin: 0px 400px;
    padding: 10px 10px 10px 10px;
    width: 45%;
    border:1px solid #00529B;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size : 14px;
    color: white;
    margin-top:2%;
    }
    .savelaterclose {
    color: black;
    float: right;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 10px 0px 0px;
    }
    .savelaterclose:hover,
    .savelaterclose:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
    }
    #tabbutton{
    float:right;
    color: white;
    padding: 6px 20px;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    margin: 10px 0px 0px 0px;
    }
    #marginright{
    margin-right: 12%
    }
    .labelright{
    float:right
    }
    .margintopone {
 	margin-top: 1%;
 }
  .inputsize1{

         width: 70px;
         background-color: #fff;
         border: 1px solid gray;
     }
 .addbutton{

    text-align:center;
     background-color: dodgerblue;
     color:white;

 }
 .border{
    border:1px solid  #00529B;
    padding:0px 0px 10px 0px;
    margin-top:1%;
    margin-left:1%;
    margin-right:1%;
 }
 .font12{
     font-size: 12px;

 }

 .maxwidth{
    max-width:10%;
 }
 @media  (max-width: 1100px){
     #column{
         width: 100%;

     }

     textarea {
     width: 55px;
     height: 50px;
 }
  .marketvalue-table-card-height{
    height:480px;
    padding-top:0px;
    width:100%;
    overflow:scroll;

    }

 .marginright{
    margin-right:20px;
 }

 .marketvalue-card-height{
    height:335px;
    padding-top:0px;

    }

 .col-2 {
     float: right;
     width: 100%;

   }

   .col-10 {
     float: right;
     width: 100%;

   }
   .col-12 {
     float: right;
     width: 100%;

   }
   .col-15 {
     float: right;
     width: 100%;

   }
   .col-20 {
     float: right;
     width: 100%;

   }

   .col-40 {
     float: right;
     width: 100%;

   }
   .col-30 {
     float: right;
     width: 100%;

   }
   .col-60 {
     float: right;
     width: 100%;

   }
 .table-month-table{
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  border-collapse: collapse;
  margin: 0px 0px 0px 2px;
  background-color: white;
  width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    word-wrap: break-word;
  border-color:"#e3e4e5" ;
 }
 .table-month-header-blue {
 border:1px solid #ddd;
  background: #13405e;
  color: white;
    text-align: center;
  font-weight: bold;

  text-align: center;
  font-size: 9px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
 }
 .table-month-header-red {
  background: #831313;
  color: white;
    text-align: center;
  font-weight: bold;

 border:1px solid #ddd;
  text-align: center;
  font-size: 9px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  }
  .table-month-td {
          border: 1.5px solid #eee;
          text-align: left;
          border-bottom: 1px solid #eee;
          position: relative;
          font-size: 9px;
          font-family:Verdana, Geneva, Tahoma, sans-serif
 }
 .inputsize1 {
     width: 50px;
     height: 20px;
       font-size:10px;
 }

 }
 @media (max-width: 800px) {
    .table-month-table{
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  border-collapse: collapse;
  margin: 0px 0px 0px 2px;
  background-color: white;
  width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    word-wrap: break-word;
  border-color:"#e3e4e5" ;
 }
 .table-month-header-blue {
 border:1px solid #ddd;
  background: #13405e;
  color: white;
    text-align: center;
  font-weight: bold;

  text-align: center;
  font-size: 6px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
 }
 .table-month-header-red {
  background: #831313;
  color: white;
    text-align: center;
  font-weight: bold;

 border:1px solid #ddd;
  text-align: center;
  font-size: 6px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  }
  .table-month-td {
          border: 1.5px solid #eee;
          text-align: left;
          border-bottom: 1px solid #eee;
          position: relative;
          font-size: 6px;
          font-family:Verdana, Geneva, Tahoma, sans-serif
 }

 .inputsize1 {
     width: 40px;
     height:15px;
     font-size:6px;
     }
 textarea {
     width: 35px;
     height: 50px;
 }
 }

 </style>
